import { firestore } from "fb";
import { doc } from "firebase/firestore";
import { useFirestoreDocument } from "@react-query-firebase/firestore";

export const useMeta = () => useFirestoreDocument(['meta', 'stocks'], doc(firestore, 'meta', 'stocks'));
